import { useEffect, useMemo } from 'react';
import type { Map } from 'immutable';
import { useDispatch, useSelector } from 'react-redux';
import type { Dispatch } from 'redux';

import { getFeatureToggles } from '../../Admin/FeatureToggles/actions';

type RootMap = Map<string, unknown>;
type FeatureToggleMap = Map<string, boolean>;

function useFeatureToggles(): string[] {
  const dispatch = useDispatch<Dispatch>();
  const featureToggles = useSelector<RootMap, FeatureToggleMap>((state) =>
    state.getIn(['global', 'featureToggles', 'data']) as FeatureToggleMap,
  );

  const features = useMemo<string[]>(
    () =>
      featureToggles.reduce<string[]>((acc, value, key) => {
        const enabledFeatures = acc!;
        return value ? enabledFeatures.concat(key!) : enabledFeatures;
      }, [])!,
    [featureToggles],
  );

  useEffect(() => {
    dispatch(getFeatureToggles());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return features;
}

export { useFeatureToggles };
